/* eslint-disable camelcase */
import { FunctionComponent } from 'react'
import styled from 'styled-components'

import AddressSearchInput from 'modules/AddressAutocomplete'

import Spacer from 'components/Spacer'

interface IImgSrcProps {
  imgSrc: string
  mobileImgSrc: string
}
const HeroImageContainer = styled.div<IImgSrcProps>`
  background: center/cover no-repeat url(${props => props.mobileImgSrc});
  width: 100%;
  height: 540px;
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    background-image: url(${props => props.imgSrc});
  }
`

const HeroContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: ${props => props.theme.colors.transparentBlackAlpha35};
`

const HeroTitle = styled.h1`
  color: ${props => props.theme.colors.grey16};
  font-weight: 800;
  font-size: 32px;
  text-align: center;
  padding: 0;
  margin: 0 15px;

  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    font-size: 42px;
  }

  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    font-size: 56px;
  }
`

const HeroSubtitle = styled.p`
  color: ${props => props.theme.colors.grey16};
  font-weight: 100;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  padding: 0;
  margin: 0 15px;

  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    font-size: 24px;
    line-height: 32px;
  }
`

interface IProps {
  title: string
  subtitle: string
  imgSrc: string
  mobileImgSrc: string
  freeToList?: boolean
}

const AddressHero: FunctionComponent<IProps> = ({
  title,
  subtitle,
  imgSrc,
  mobileImgSrc,
  freeToList,
}) => (
  <HeroImageContainer
    imgSrc={imgSrc}
    mobileImgSrc={mobileImgSrc}
  >
    <HeroContentContainer>
      <HeroTitle>{title}</HeroTitle>
      <Spacer size={10} />
      <HeroSubtitle>{subtitle}</HeroSubtitle>
      {freeToList && <HeroSubtitle>Free to list*, pay only when you sell.</HeroSubtitle>}
      <Spacer
        size={50}
        tabletSize={40}
        responsiveSize={30}
      />
      <AddressSearchInput
        width="90vw"
        tabletWidth="720px"
        buttonWidth={250}
      />
    </HeroContentContainer>
  </HeroImageContainer>
)

export default AddressHero
